const isMobile = () => {
	if (navigator.userAgent.indexOf('Android') !== -1) {
		return true
	}

	if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
		return true
	}

	return false
}

export default isMobile